

/**
 * Created by zhqmac on 2018/5/11.
 */
import React, {Component} from 'react';
import MemoryModel from '../models/MemoryModel'
import MatchView from "../views/MatchView"

const styles = {
    //主标签样式
    container: {
        display: 'flex',
        flex: 1,
        background: "green",
        flexDirection: "column",
    },
    title: {
        marginTop: 32,
        textAlign: 'center',
        color: 'red',
        fontSize: "24px",
    },
    editFrame: {
        marginBottom: 0,
        marginTop: 0,
        display: 'flex',
        flex: 1,
        margin: 16,
        overflow: "auto",
    },
    leftBox: {
        flex: 1,
        backgroundColor: "#ffffff6e",
        marginRight: 8,
        borderRadius: 10,
        padding: 16,
        overflow:"auto",
        // display: 'flex',
    },

    rightBox: {
        flex: 1,
        backgroundColor: "#ffffff6e",
        marginLeft: 8,
        borderRadius: 10,
        padding: 16,
    },
    textArea: {
        width:"100%",
        height:"100%",
        backgroundColor:"transparent",
        border:"aliceblue"
    }

};

class Flow extends Component {
    state = {
        showDialog: false,
        result:"",

    };

    constructor() {
        super();
        console.log("constructor");
    }

    componentDidMount() {
        console.log("DidMount");
    }

    textOnChange = (result) => {
        let type = result["type"];
        let data = result["data"];
        let xml = "";
        for(var key in data){
            let match = `<match type="{0}" text="{1}">`;
            match = match.format(type,key);
            let array = data[key];
            for (let i = 0;i<array.length;i++){
                let value = array[i];
                let answer = "\t" + ` <answer>{0}</answer>`;
                answer = answer.format(value);
                match = match+"\n"+answer;
            }
            match = match + "\n" + `</match>`;
            if (xml === ""){
                xml = match;
            } else {
                xml = xml + "\n" + match;
            }
        }

        this.setState(
            {
                result:xml,
            }
        )
    };

    render() {
        return (
            <div style={styles.container}>
                <div style={styles.title}>
                    第5维度
                </div>
                <div style={styles.editFrame}>
                    <div style={styles.leftBox}>
                        <MatchView onFinish={this.textOnChange}></MatchView>
                    </div>
                    <div style={styles.rightBox}>
                        <textarea style={styles.textArea}
                                  value={this.state.result}
                                  readOnly={true}
                        >
                        </textarea>
                    </div>

                </div>
            </div>

        );
    }
}

export default Flow;


